/*
 * @Author: Latte
 * @Date: 2021-08-13 11:07:55
 * @LAstEditors: Latte
 * @LastEditTime: 2021-10-18 15:56:32
 * @FilePath: \Siui.Cloud.Medical.Web\src\config\tableConfig\systemMgt\diagnosticMgt\diagnosticTeamMember.js
 */

export const teamMemberConf = Object.freeze({
	tableColumnOpt: [
		{ label: "提交的会诊申请数", prop: "consultationReqCount", width: "50" },
		{ label: "成员 ID", prop: "userID", width: "100" },
		{ label: "成员姓名", prop: "firstName", width: "100" },
		{ label: "成员手机号", prop: "mobilePhone" },
		{
			label: "成员加入时间",
			prop: "joinTime",
			hasFormatter: true,
			formatter: function(val) {
				return new Date(val).toLocaleString();
			},
		},
		{
			label: "成员角色",
			prop: "role",
			hasFormatter: true,
			formatter: function(val) {
				switch (val) {
					case 0:
						return "普通用户";
					case 1:
						return "管理员";
					case 2:
						return "团长，创建者";
				}
			},
		},
		{
			label: "当前成员在会诊系统的角色",
			prop: "consultationUserRole",
			hasFormatter: true,
			formatter: function(val) {
				switch (val) {
					case -1:
						return "普通角色";
					case 0:
						return "医生";
					case 1:
						return "会诊专家";
					case 2:
						return "医生&会诊专家";
				}
			},
		},
		{
			label: "权限",
			prop: "permission",
			hasFormatter: true,
			formatter: function(val) {
				switch (val) {
					case 0:
						return "允许会诊申请但不允许会诊诊断";
					case 1:
						return "允许会诊申请和会诊诊断";
				}
			},
		},
		{ label: "完成的报告数", prop: "reportCount", width: "50" },
		{ label: "提交的会诊数", prop: "consultationCount", width: "50" },
	],
  hasToolbar: false,
	hasStatus: false,
	hasOperation: true,
	operationWidth: "500",
});
